import {Component, OnInit, AfterViewInit} from '@angular/core';
import {LoginForm} from '../../../models/';
import {ResendForm} from '../../../models/';
import {AuthService, ScrollService, SearchService, UserService, MessagesServices, ScrollParams} from '../../api';
import {Router, ActivatedRoute} from '@angular/router';
import {PlayerService} from '../../player/services/player.service';
import {ToastyService, ToastOptions} from 'ng2-toasty';
import {MdDialog, MdDialogRef} from '@angular/material';
import {CartService} from '../../api';
import { Helper } from '../../helper';
import * as _ from 'lodash';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterViewInit {
    public model: LoginForm;
    public resend: ResendForm;
    private errorArray: Array<any> = [];
    private token: string = '';
    private redirectUrl: string = null;
    private verified: boolean = false;
    private isError: boolean = false;
    private failed: boolean = false;
    private already: boolean = false;
    private resendfrom: boolean = false;
    checkIfTrue: boolean = false;
    dialogRef: MdDialogRef<LogoutDialog>;
    private messages: any = new Array<any>();
    private helper = new Helper();
    private scrollParams = new ScrollParams();
    msg1: any = '';
    title1: any = '';
    msg2: any = '';
    title2: any = '';

    constructor(private userService: UserService, private playerService: PlayerService, private sm: MessagesServices, private authService: AuthService, private router: Router, private route: ActivatedRoute,
    private toastyService: ToastyService, private scrollService: ScrollService, private searchService: SearchService, public dialog: MdDialog, private cartService: CartService) {
        this.model = new LoginForm();
        this.resend = new ResendForm();
        if (this.authService.isUserLoggedIn()) {
            this.router.navigate(['']);
        }
        if (this.route.snapshot.data['verified'] === true) {
            this.verified = true;
        }
        if (this.route.snapshot.data['failed'] === true) {
            this.failed = true;
        }
        if (this.route.snapshot.data['already'] === true) {
            this.already = true;
        }
        //getting messages from db
        this.messages = this.sm.messags;
        this.setMessages();
    }

    /**
     * setting system messages
     **/
    setMessages() {
        this.msg1 = '';
        this.title1 = '';
        if (this.messages) {
            for (var i = 0; i < this.messages.length; i++) {
                if (this.messages[i].event == 'WG_EVENT_VERIFICATION_EMAIL_SENT_SUCCESSFULLY') {
                    this.title1 = this.messages[i].title;
                    this.msg1 = this.messages[i].message;
                }
                if (this.messages[i].event == 'WG_EVENT_EMAIL_NOT_FOUND') {
                    this.title2 = this.messages[i].title;
                    this.msg2 = this.messages[i].message;
                }
            }
        }
    }

    ngOnInit() {
        this.checkIfTrue = false;
        this.checkIfTrue = this.route.snapshot.queryParams['checkIfTrue'];
        if (this.checkIfTrue) {
            this.playerService.stop();
            this.scrollService.closeSideNav();
            this.playerService.setCurrentTrack(null);
            this.playerService.clearPlaylist(() => {
                //cleared playlist
            });
        }
        this.route.params.subscribe((params) => {
            if (!this.authService.isUserLoggedIn()) {
                if (params['token'] && params['token'].length > 0) {
                    this.token = params['token'];
                    if (this.token.length > 0) {
                        this.authService.verifySignup(this.token).subscribe((data: any) => {
                            let response = data.json();
                            if (response.code == 'ok') {
                                this.router.navigate(['/login/verified']);
                            } else {
                                this.router.navigate(['/login/failed']);
                            }
                        }, (err) => {
                            this.router.navigate(['/login/failed']);
                        });
                    }
                }
            } else {
                if (params['token'] && params['token'].length > 0) {
                    this.token = params['token'];
                    if (this.token.length > 0) {
                        this.dialogRef = this.dialog.open(LogoutDialog, {
                            disableClose: false,
                            width: '400px',
                            height: '200px',
                        });
                        this.dialogRef.componentInstance.token = this.token;
                    }
                }
            }

            if (params['redirect'] && params['redirect'].length > 0) {
                //redirected to required login...
                this.redirectUrl = params['redirect'];
            }
        });
    }

    ngAfterViewInit() {
        this.scrollService.toggleProgressBar(false);
    }

    trimSpaces() {
        this.model.screenname = this.model.screenname.replace(/\s+/g, '_');
        this.model.screenname = this.model.screenname.replace(/_{2,}/g, '_');
        this.model.screenname = this.model.screenname.replace(/-{2,}/g, '-');
    }

    login() {
        this.scrollService.toggleProgressBar(true);
        this.resend.screenname = this.model.screenname;
        this.resend.password = this.model.password;
        this.authService.login(this.model).subscribe((data) => {
            if(data.code == "error") {
                this.isError = true;
            } else {
                this.getUserDiscoveries();
                this.userService.getUserEventEmitter().emit({'name': "user:login"});
                this.cartService.getCart();
                if (data.status === 6 || (data.optional_race_id == null || data.optional_race_id <= 0)) {
                    this.router.navigate(['/demographic-profile'], {queryParams: {verified: this.verified}});
                } else if (data.status === 7 || (data.marital_status == null || data.has_children == null
                        || data.optional_income_id == null || data.optional_income_id <= 0 || data.optional_education_id == null
                        || data.optional_education_id <= 0)) {
                    this.router.navigate(['/lifestyle-profile']);
                } else {
                    if (this.redirectUrl != null)
                        this.router.navigate([this.redirectUrl]);
                    else
                        this.router.navigate(['']);
                }
                this.authService.checkDefaultPackage.next(true);
            }
            
            this.scrollService.toggleProgressBar(false);
        }, (err) => {
            console.log(err)
            this.isError = true;
            this.scrollService.toggleProgressBar(false);
            this.handleErrors(err);
        });
    }

    getUserDiscoveries() {
        let type = "discoveries";
        let discoveries = [];
        this.userService.getDiscoveriesRelations(0, '', null, 30).subscribe((res) => {
            if (res.length > 0) {
                res.forEach((arrayItem) => {
                    arrayItem.item.isSongDownloaded = ((!arrayItem.item.isSongDownloaded) ? 'Streaming' : 'Owned');
                    discoveries.push(arrayItem);
                });
            }
            discoveries = _.uniqBy(discoveries, 'id');
            this.helper.setLocalStore(type, discoveries);
        });
    }

    resendSave() {
        this.scrollService.toggleProgressBar(true);
        this.authService.resendEmail(this.resend).subscribe((data) => {
            localStorage.setItem('resendemail', this.resend.email);
            let response = data.json();
            if (response.code == 'ok') {
                let toastOptions: ToastOptions = {
                    title: this.title1,
                    msg: this.msg1,//Account verification email has been sent successfully
                    showClose: true,
                    timeout: 2000,
                    theme: 'default'
                };
                this.toastyService.success(toastOptions);
            } else {
                let toastOptions: ToastOptions = {
                    title: this.title2,
                    msg: this.msg2,//Email Not Found
                    showClose: true,
                    timeout: 2000,
                    theme: 'default'
                };
                this.toastyService.error(toastOptions);
            }
            this.scrollService.toggleProgressBar(false);
            this.resendfrom = false;
            this.errorArray = [];

        }, (err) => {
            this.scrollService.toggleProgressBar(false);
            this.handleErrors(err);
        });
    }

    resendFrom() {
        this.resendfrom = true;
        this.scrollService.toggleProgressBar(false);
        this.scrollService.toggleProgressBar(false);
    }

    resendConfirmEmail() {
        this.authService.resendComfirmEmail(btoa(localStorage.getItem('resendemail'))).subscribe((res) => {
            let response = res.json();
            if (response.code == 'ok') {
                let toastOptions: ToastOptions = {
                    title: this.title1,
                    msg: this.msg1,
                    showClose: true,
                    timeout: 2000,
                    theme: 'default'
                };
                this.toastyService.success(toastOptions);
            } else {
                let toastOptions: ToastOptions = {
                    title: this.title2,
                    msg: this.msg2,
                    showClose: true,
                    timeout: 2000,
                    theme: 'default'
                };
                this.toastyService.error(toastOptions);
            }
        });
    }

    handleErrors(err: any) {
        this.errorArray = [];
        let validationErrors = JSON.parse(err._body);
        if (err._body) {
            for (let index = 0; index < validationErrors.length; index++) {
                if (validationErrors[index].field == 'password-inactive') {
                    localStorage.setItem('resendemail', validationErrors[index].message);
                }
                this.errorArray[validationErrors[index].field] = validationErrors[index].message;
            }
        }
    }
}

@Component({
    selector: 'dialog-logout',
    templateUrl: 'logout.component.html',
})

export class LogoutDialog implements OnInit {
    public token: string = '';
    
    constructor(public dialogRef: MdDialogRef<LogoutDialog>, private sm: MessagesServices, private userService: UserService, private authService: AuthService, private router: Router) {
    }

    ngOnInit() {
    }

    confirmSelection() {
        this.signOut();
        this.authService.verifySignup(this.token).subscribe((data: any) => {
            let response = data.json();
            if (response.code == 'ok') {
                this.router.navigate(['/login/verified']);
            } else {
                this.router.navigate(['/login/failed']);
            }
        }, (err) => {
            this.router.navigate(['/login/failed']);
        });
        this.dialogRef.close();
    }

    signOut() {
        this.authService.logOut();
        this.userService.getUserEventEmitter().emit({'name': 'user:logout'});
    }
    
}



// WEBPACK FOOTER //
// ./src/app/user/login/login.component.ts